import { Div } from '../../../../base/components/native/div'
import { ABSOLUTE, Y } from '../../../../base/helpers/style'
import { AssistantClose } from './assistant-close'
import { AssistantGenrerate } from './assistant-generate'
import { AssistantOptions } from './assistant-options'
import { AssistantSelector } from './assistant-selector'

export const Assistant = () => {

    const base = Div()
    const background = Div()
    const content = Div()
    const selector = AssistantSelector()
    const close = AssistantClose()
    const options = AssistantOptions()
    const generate = AssistantGenrerate()
    content.append(selector, close, options, generate)
    base.append(background, content)

    close.el.onclick = () => base.emit('close')
    options.on('select', selector.apply)
    options.render('type')
    selector.on('assistant-selector-type', options.render)
    generate.el.onclick = () => {
        base.emit('submit', selector.getValue())
        options.style({ display: 'none' })
        generate.style({ display: 'none' })
        base.el.scrollIntoView()
    }
    selector.el.onclick = () => {
        options.style({ display: 'flex' })
    }
        
    content.cssClass({
        position: 'relative',
        margin: '0 100px',
        boxShadow: '4px 4px 70px -10px #00000040',
        color: '#777777',
        backgroundColor: '#fff',
        borderRadius: '10px',
        zIndex: '2',
        padding: '20px 30px',
        '@media (max-width: 768px)': {
            margin: '0 10px',
            padding: '10px'
        }
    })
    background.cssClass({
        ...Y(60),
        ...ABSOLUTE,
        bottom: '50px',
        backgroundColor: '#fff'
    })
    base.cssClass({
        marginBottom: '0px',
        position: 'sticky',
        top: '10px',
        display: 'none',
        zIndex: '99',
    })

    return Object.assign(base, {
        tryAgain() {
            options.style({ display: 'flex' })
            generate.style({ display: 'flex' })
            base.el.scrollIntoView()
        }
    })
}